import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserInfo } from '@app/_models/user-info';
import { Account } from '@app/_models/account';
import { ChangePasswordRequest } from '@app/_models/change-password-request';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);


  login(loginData: {login: string, password: string}): Observable<UserInfo> {
    return this.http.post<UserInfo>(`${environment.apiUrl}/api/login`, loginData);
  }

  me(): Observable<Account> {
    return this.http.get<Account>(`${environment.apiUrl}/api/me`);
  }

  requestPasswordChange(changePasswordData: {email: string}) {
    return this.http.post(`${environment.apiUrl}/rest/request-change-password`, changePasswordData);
  }

  changePassword(request: ChangePasswordRequest) : Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/change-password`, request);
  }

  changeSignature(signedData: any) {
    return this.http.post(`${environment.apiUrl}/api/change-signature`, signedData);
  }

  changeMobilePhone(requestData: { mobilePhone: string }) {
    return this.http.post(`${environment.apiUrl}/api/change-mobile-phone`, requestData);
  }
}
